<template>
  <div>
    <stihl-flag :message="$t('adm.label.history')" />
    <div class="container history">
      <div class="row" v-for="(item, i) in history" :key="i">
        <div class="col-4 hist-col">{{ formatDate(item.timestamp) }}</div>
        <div class="col-8 hist-col hist-last-col">
          <img src="@/assets/img/icons/circle-check-colored.svg" alt="Success" v-if="item.code === 'VERIFIED'">
          {{ transform(item) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import StihlFlag from '@/components/ui/StihlFlag.vue';
import { i18n } from '@/lang';
import { HistoryItem } from '@/components/backend';
import { localeDateFormat } from '@/components/utils';

export default defineComponent({
  name: 'HistoryPanel',
  components: { StihlFlag },
  emits: ['userClick'],
  props: {
    history: { type: Array as PropType<HistoryItem[]>, default: new Array<HistoryItem>() },
  },
  methods: {
    transform(item: HistoryItem): string {
      return this.$t(`adm.label.userHistory.${item.code}`);
    },
    formatDate(date: string) {
      return localeDateFormat(date, i18n.global.locale);
    },
  },
});
</script>

<style>
.history .row:nth-child(odd) {
  background: var(--grey-light);
}

.history .hist-col {
  display: flex;
  height: 2.5rem;
  padding: 0.5rem 1rem;
  align-items: center;
  flex: 1 0 0;
  gap: .5rem;

  color: black;
  font-size: 0.875rem;
  line-height: 1rem;

  border-right: 1px solid var(--grey-base);
}

.history .hist-last-col {
  border-right: 0;
}
</style>
